import React, { useState, useEffect, useCallback } from "react";
import { Field, reduxForm, formValueSelector, change } from "redux-form";
import { connect, useDispatch } from "react-redux";
import { Form, Input, Button, Dropdown } from "semantic-ui-react";

const typeOptions = [
  { key: "personal", text: "개인", value: "개인" },
  { key: "shared", text: "공용", value: "공용" }
];

const renderInputField = ({
  input,
  data,
  select,
  disabled,
  placeholder
}) => {
  return select === "reqType" ? (
    <Dropdown
      selection
      style={{ width: 100 }}
      options={data}
      value={input.value || data[0].value}
      onChange={(_, { value }) => input.onChange(value)}
    />
  ) : (
    <Input {...input} disabled={disabled} placeholder={placeholder} />
  );
};

let SearchBar = props => {
  const dispatch = useDispatch();
  const { handleSubmit, selectconditionvalue } = props;
  const [onInput, setOnInput] = useState(true);
  const [placeholderText, setPlaceHolderText] = useState("");
  const [select, setSelect] = useState("");

  const onSelectChange = useCallback(
    (event, newValue) => {
      if (newValue === "reqType") {
        setSelect("reqType");
        dispatch(change("searchBarForm", "selectValue", "개인"));
      } else {
        setSelect("");
        dispatch(change("searchBarForm", "selectValue", ""));
      }
    },
    [dispatch]
  );

  useEffect(() => {
    if (selectconditionvalue === "all" || selectconditionvalue === null) {
      setOnInput(true);
    } else {
      setOnInput(false);
    }

    if (selectconditionvalue === "reqYearMonth") {
      setPlaceHolderText("ex. 202001");
    } else {
      setPlaceHolderText("");
    }
  }, [selectconditionvalue]);

  return (
    <Form>
      <Form.Group>
        <Form.Field>
          <Field
            component="select"
            name="selectCondition"
            onChange={onSelectChange}
          >
            <option value="all">전체</option>
            <option value="bookName">책이름</option>
            {window.localStorage.getItem("adminYn") === "Y" && (
              <>
                <option value="empNum">사원번호</option>
                <option value="mbrName">이름</option>
              </>
            )}
            <option value="reqYearMonth">신청년월</option>
            <option value="reqType">개인/공용</option>
          </Field>
        </Form.Field>
        <Form.Field>
          <Field
            name="selectValue"
            placeholder={placeholderText}
            component={renderInputField}
            disabled={onInput}
            data={typeOptions}
            props={{
              select: select
            }}
          />
        </Form.Field>
        <Form.Field>
          <Button
            type="button"
            onClick={handleSubmit(props.onSubmit)}
            color={"blue"}
          >
            검색
          </Button>
        </Form.Field>
      </Form.Group>
    </Form>
  );
};

SearchBar = reduxForm({
  form: "searchBarForm",
  initialValues: { selectCondition: null, selectValue: "" }
})(SearchBar);

const selector = formValueSelector("searchBarForm");

SearchBar = connect(state => {
  const selectconditionvalue = selector(state, "selectCondition");
  return {
    selectconditionvalue
  };
})(SearchBar);

export default SearchBar;
